import { configApi } from './configApi';

export const api = configApi();
